// export let OrganizationModalFieldsJSON = {
//   "1719383709240-phoneNumber": {
//     elementid: 1719383709240,
//     elementtype: "phoneNumber",
//     "display-fieldlabel": "Contact No",
//     "display-placeholder": "Enter",
//     "display-labelposition": "top",
//     "database-label": "contact_number",
//     "validation-pattern": "^[0-9+\\-\\s()]*$",
//   },
//   "1719383722105-customSelect": {
//     elementid: 1719383722105,
//     elementtype: "customSelect",
//     "data-datasource": "customvalues",
//     "data-customvalue": "ACTIVE#INACTIVE",
//     "display-fieldlabel": "Status",
//     "display-noofcolumns": "2",
//     "display-labelposition": "top",
//     "display-required": 1,
//   },
//   "1719383687656-textfield": {
//     elementid: 1719383687656,
//     elementtype: "textfield",
//     "display-fieldlabel": "Name",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//     "display-required": 1,
//   },
//   "1719383715621-textfield": {
//     elementid: 1719383715621,
//     elementtype: "textfield",
//     "display-fieldlabel": "Email",
//     "display-placeholder": "Enter",
//     "validation-maxlength": "2000",
//     "validation-minlength": "0",
//     "display-labelposition": "top",
//   },
// };

export let OrganizationModalFieldsJSON = {
  "1719383709240-phoneNumber": {
    elementid: 1719383709240,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Contact No",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "database-label": "contact_number",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
    "display-required": 1,
  },
  "1692362019775-columns": {
    elementid: 1692362019775,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719383722105-customSelect": {
    elementid: 1719383722105,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1719383687656-textfield": {
    elementid: 1719383687656,
    elementtype: "textfield",
    "display-fieldlabel": "Name",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383715621-email": {
    elementid: 1719383715621,
    elementtype: "email",
    "display-fieldlabel": "Email",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
    "display-required": 1,
  },
  "1719383687657-textfield": {
    elementid: 1719383687657,
    elementtype: "textfield",
    "display-fieldlabel": "GST",
    "display-placeholder": "Enter GST Number",
    "validation-maxlength": "15",
    "database-label": "GSTIN",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383687658-textfield": {
    elementid: 1719383687658,
    elementtype: "textfield",
    "display-fieldlabel": "Company PAN Number",
    "display-placeholder": "Enter PAN Number",
    "database-label": "company_pan_number",
    "validation-maxlength": "10",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383687659-number": {
    elementid: 1719383687659,
    elementtype: "number",
    "display-fieldlabel": "Bank Account Number",
    "display-placeholder": "Enter Bank Number",
    "validation-maxlength": "17",
    "validation-minlength": "8",
    "database-label": "bankacc_account_number",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383687661-textfield": {
    elementid: 1719383687661,
    elementtype: "textfield",
    "display-fieldlabel": "Bank Name",
    "display-placeholder": "Enter Bank Name",
    "validation-maxlength": "1000",
    "validation-minlength": "0",
    "database-label": "bankacc_bank_name",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383687662-textfield": {
    elementid: 1719383687662,
    elementtype: "textfield",
    "display-fieldlabel": "Beneficiary Name",
    "display-placeholder": "Enter beneficiary Name",
    "validation-maxlength": "1000",
    "validation-minlength": "0",
    "database-label": "bankacc_benef_name",
    "display-labelposition": "top",
    "display-required": 1,
  },

  "1719383687663-textfield": {
    elementid: 1719383687663,
    elementtype: "textfield",
    "display-fieldlabel": "IFSC Number",
    "display-placeholder": "Enter IFSC Number",
    "validation-maxlength": "1000",
    "validation-minlength": "0",
    "database-label": "bankacc_branch_IFSC",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719383687660-textarea": {
    elementid: 1719383687660,
    elementtype: "textarea",
    "display-fieldlabel": "Address",
    "display-placeholder": "Enter address",
    "validation-maxlength": "1000",
    "validation-minlength": "0",
    "database-label": "address",
    "display-labelposition": "top",
    "display-required": 1,
  },
};
